import '../styles/main.scss';
import { initInputs } from '@components/inputs';
import { initAccordions } from '@components/accordions';
import { initModals } from '@components/modals';
import { initVideoControls } from '@components/media';
import { initCookiebotLinks } from '@components/cookiebot';

(() => {
  initInputs();
  initAccordions();
  initModals();
  initVideoControls();
  initCookiebotLinks();
})();
